export default __webpack_public_path__ + "static/media/left-image.161920f0.png";